import React, { Suspense } from 'react';
import { useTypedSelector } from '@hooks';
import { useAuth } from '@hooks/useAuth';
import { useDebounced } from '@helpers/useDebounced';

const CopyModalAssets = React.lazy(() => import('./CopyModalAssets'));
const CopyModalFolder = React.lazy(() => import('./CopyModalFolder'));

export default function CopyModalContainer() {
  const { user } = useAuth();
  const modalState = useTypedSelector(({ modal }) => modal.copyModal);
  const visibleDebounced = useDebounced(modalState?.visible, 300, false);
  const visible = modalState?.visible || visibleDebounced;
  if (!modalState || !visible || !user) return null;

  return (
    <Suspense fallback={null}>
      {modalState.type === 'assets' && <CopyModalAssets {...modalState} />}
      {modalState.type === 'folder' && <CopyModalFolder {...modalState} />}
    </Suspense>
  );
}
